<template>
  <v-list-item v-on="rowClickEnabled && item.rowClick ? { click: item.rowClick } : {}"
               class="calendar-event-list-item">
    <v-list-item-content>
      <v-list-item-title>
        {{ $options.filters.date(item.calendarEvent.plannedService.scheduleDate) }}
        {{ item.calendarEvent.plannedService.name }}
      </v-list-item-title>
      <v-list-item-subtitle> {{ $options.filters.device(item.calendarEvent.plannedService.device) }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="showActions && !!item.rowActions && !!item.rowActions.length > 0">
      <entity-table-row-end-action-menu :actions="item.rowActions"/>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import EntityTableRowEndActionMenu from '@/components/entity-crud/EntityTableRowEndActionMenu';

export default {
  name: 'PlannedServiceEventListItem',
  components: { EntityTableRowEndActionMenu },
  props: {
    item: {
      type: Object,
      required: true,
      validator: item => {
        return !!item.calendarEvent;
      },
    },
    showActions: {
      type: Boolean,
    },
    rowClickEnabled: {
      type: Boolean,
    },
  },
};
</script>

<style>

</style>
